import _createForOfIteratorHelper from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import getAlphanumFromUnicodeRange from './getAlphanumFromUnicodeRange';
import makeAlphanumMaxlenComputer from './makeAlphanumMaxlenComputer';
import makeCSEngine from './makeCSEngine';
import makeCSRenderer from './makeCSRenderer';
import codepointLength from './utils/codepointLength';
var mod = function mod(value, divisor) {
  return (value % divisor + divisor) % divisor;
};
function makeCSRendererFromFormatter(formatter) {
  return makeCSRenderer(makeCSEngine(formatter));
}
function getMaxLenInSymbols(lens) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var to = arguments.length > 2 ? arguments[2] : undefined;
  to = typeof to === 'number' ? to : lens.length;
  return lens.slice(from, to + 1).reduce(function (p, c) {
    return Math.max(p, c);
  }, 0);
}
function _numeric(renderer, length) {
  return renderer.withMaxLengthComputer(makeAlphanumMaxlenComputer(length, false)).withNegative('-');
}
function _alphabetic(renderer, length) {
  return renderer.withMaxLengthComputer(makeAlphanumMaxlenComputer(length, true)).withRange(1, Infinity);
}
/**
 * A static object to build counter style renderers.
 * See {@link CounterStyleStatic}.
 *
 * @public
 */
var CounterStyle = Object.freeze({
  raw: function raw(formatter) {
    return makeCSRendererFromFormatter(formatter);
  },
  cyclic: function cyclic() {
    for (var _len = arguments.length, symbols = new Array(_len), _key = 0; _key < _len; _key++) {
      symbols[_key] = arguments[_key];
    }
    var symbolLenghts = symbols.map(codepointLength);
    var maxLen = getMaxLenInSymbols(symbolLenghts);
    var renderer = symbols.length === 1 ? makeCSRendererFromFormatter(function () {
      return symbols[0];
    }) : makeCSRendererFromFormatter(function (index) {
      return symbols[mod(index - 1, symbols.length)];
    });
    return renderer.withMaxLengthComputer(function (min, max) {
      return maxLen === 1 || max - min + 1 >= symbols.length ? maxLen : getMaxLenInSymbols(symbolLenghts, min - 1, max - 1);
    });
  },
  fixed: function fixed() {
    for (var _len2 = arguments.length, symbols = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      symbols[_key2] = arguments[_key2];
    }
    var symbolLenghts = symbols.map(codepointLength);
    var maxLen = getMaxLenInSymbols(symbolLenghts);
    return makeCSRendererFromFormatter(function (index) {
      return symbols[index - 1];
    }).withRange(1, symbols.length).withMaxLengthComputer(function (min, max) {
      return maxLen === 1 ? maxLen : getMaxLenInSymbols(symbolLenghts, min - 1, max - 1);
    });
  },
  symbolic: function symbolic() {
    for (var _len3 = arguments.length, symbols = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      symbols[_key3] = arguments[_key3];
    }
    return makeCSRendererFromFormatter(function (index) {
      return symbols[mod(index - 1, symbols.length)].repeat(Math.ceil(index / symbols.length));
    }).withRange(1, Infinity).withMaxLengthComputer(function (min, max, defaultCmp) {
      // Just iterate over the last n elements until max, with n the number
      // of symbols.
      return defaultCmp(max < symbols.length ? min : max - symbols.length, max);
    });
  },
  alphabetic: function alphabetic() {
    for (var _len4 = arguments.length, symbols = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      symbols[_key4] = arguments[_key4];
    }
    return _alphabetic(makeCSRendererFromFormatter(function (index) {
      var result = '';
      while (index > 0) {
        index--;
        result = symbols[mod(index, symbols.length)] + result;
        index = Math.floor(index / symbols.length);
      }
      return result;
    }), symbols.length);
  },
  numeric: function numeric() {
    for (var _len5 = arguments.length, symbols = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      symbols[_key5] = arguments[_key5];
    }
    return _numeric(makeCSRendererFromFormatter(function (index) {
      if (index === 0) {
        return symbols[0];
      } else {
        var result = '';
        while (index > 0) {
          result = symbols[mod(index, symbols.length)] + result;
          index = Math.floor(index / symbols.length);
        }
        return result;
      }
    }), symbols.length);
  },
  numericFromUnicodeRange: function numericFromUnicodeRange(originUnicode, base) {
    return _numeric(makeCSRendererFromFormatter(function (index) {
      return getAlphanumFromUnicodeRange(index, originUnicode, base, false);
    }), base);
  },
  alphabeticFromUnicodeRange: function alphabeticFromUnicodeRange(originUnicode, alphabetLen) {
    return _alphabetic(makeCSRendererFromFormatter(function (index) {
      return getAlphanumFromUnicodeRange(index, originUnicode, alphabetLen, true);
    }), alphabetLen);
  },
  additive: function additive(symbols) {
    var values = Object.keys(symbols).map(function (value) {
      return parseInt(value, 10);
    }).sort(function (a, b) {
      return b - a;
    });
    return makeCSRendererFromFormatter(function (index) {
      if (index === 0) {
        return symbols[0];
      }
      var result = '';
      var _iterator = _createForOfIteratorHelper(values),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          if (index >= value && value > 0) {
            var repeat = Math.floor(index / value);
            result += symbols[value].repeat(repeat);
            index -= repeat * value;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return index === 0 ? result : undefined;
    }).withRange(values.length ? values[values.length - 1] : 0, 0 in symbols && values.length === 1 ? 0 : values.length ? Infinity : -1);
  }
});
export default CounterStyle;